export default () => ({
  isShown: false,
  editId: null,
  pagesList: [],
  isPageEditable: {},
});
